module.exports = __webpack_public_path__ + "media/correcto_efecto_de_sonido.067145ae.mp3";